import api from "./api";
import ApiBase from "./apiBase";

const vendorCategoryOverridesApi = new ApiBase("/vendors/vendor_category_overrides");

export default vendorCategoryOverridesApi;

